import React, {useEffect, useState} from "react";
import "./SendManagement.scss";
import {SendManagementCurrent} from "./SendManagementCurrent/SendManagementCurrent";
import {SendManagementHistory} from "./SendManagementHistory/SendManagementHistory";
import {HomeHeader} from "../../Components";
import {
    courierManagerArchivedOrders_api,
    courierManagerOrders,
    courierManagerOrders_api
} from "./SendManagementService";

const dd = {
    "links":{"next":null,"previous":null}
    ,"count":1,"total_pages":1,"results":[{"uid":"SbTwa5GGvQ","created":"2020-12-20T12:07:19.819174+03:30","status":13,"items":[{"uid":"siKzHzpDQx","name":"پنل دور شیشه ای مهتابی 30 وات پارس شهاب\n","quantity":3,"per_amount":1439873,"amount":4319619,"product_id":106741,"product":{"uid":"EWxmSNsCrL","name":"پنل دور شیشه ای مهتابی 30 وات پارس شهاب\n","price_original":1515656,"price":1439873,"stock":20,"is_available":true,"image":"https://s3.mobank.co/loyalty-media/product/product/images/EWxmSNsCrL"},"per_discount":75783,"discount":227349,"original_amount":4546968,"is_canceled":false,"pay_status":2,"picked_quantity":0}],"amount":4319619.0,"from_shipping_time":"2020-12-20T15:00:00.818743+03:30","to_shipping_time":"2020-12-20T21:00:00.818743+03:30","pay_status":2,"registered":"2020-12-20T12:07:22.320069+03:30","paid_at":"2020-12-20T12:07:56.572728+03:30","cash_desk_code":null,"courier":{"uid":"UZTVwKKVxR","phone":"09338957321","first_name":"علی اصغر","last_name":"سلطانی","gender":null,"image":"https://s3.mobank.co/loyalty-media/user/user/images/user_image_38de0568-d055-4aaf-80eb-6beb5a232d46.jpg"},"user":{"uid":"kqpZdzrB7P","phone":"09354554905","first_name":"saeed","last_name":"mosleh taklimi","gender":null,"image":"https://s3.mobank.co/loyalty-media/user/user/images/user_image_6c36aa9e-2dbf-4f3b-bac9-404982aea9f9.jpg"},"address":{"uid":"in55LRVyjS","title":"","postal_code":"1245124512","coordinate":{"uid":"bRbDMfy2av","latitude":"35.7136860000000000","longitude":"51.4226350000000000"},"is_default":true,"city":389,"address":"boooshehr"}}]}

function SendManagement() {

    const [tabIndex,set_tabIndex] = useState(1)

    const [currents,set_currents] = useState([])
    const [currentPage,set_currentPage] = useState(1)

    const [history,set_history] = useState([])
    const [historyPage,set_historyPage] = useState(1)



    useEffect(()=>{
        getData()
    },[])

    const getData = () =>{
        courierManagerOrders_func()
        courierManagerOrdersArchived_func();
    }

    useEffect(()=>{
        setInterval(()=>{
            window.currentPage = 0
            getData()
        },120000)
    },[])


    const courierManagerOrders_func= async ()=>{
        const response = await courierManagerOrders_api(currentPage);
        console.log("Response : ",response.data)
        //response.data = dd
        set_currents(response.data.results)
        //set_history(response.data.results)
    }



    const courierManagerOrdersArchived_func= async ()=>{
        const response = await courierManagerArchivedOrders_api(currentPage);
        console.log("history  : ",response.data)
        set_history(response.data.results)
    }

    const changeTab = (index)=>{
        set_tabIndex(index);
    }

    return(
        <div className="packMan-container">
            <HomeHeader/>
            <div className="packMan-body">
                <div className="packMan-tab">
                    <div className={tabIndex===2?"packMan-tab-item active":"packMan-tab-item"}>
                        <span  onClick={()=>{
                            getData()
                            changeTab(2)
                        }}>آرشیو ارسال شده ها</span>
                    </div>
                    <div className={tabIndex===1?"packMan-tab-item active":"packMan-tab-item"}>
                        <span onClick={()=>{
                            getData()
                            changeTab(1)
                        }}>سفارشات جدید</span>
                    </div>
                </div>

                <br/>

                {tabIndex===1?<SendManagementCurrent data={currents}/>:null}
                {tabIndex===2?<SendManagementHistory data={history}/>:null}
            </div>
        </div>
    )

}

export {SendManagement};
